// Lista de usuarios habilitados para acceder a la aplicación
export const allowedUsers = [
  // Ejemplo de usuarios permitidos:
  // "nbobb@grupoaoniken.com.ar"
];
